import React from "react";

function SwitchHorizontal2Icon({ fill, ...restProps }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M7.64 2.068c-.154.053-.489.37-2.293 2.167-1.181 1.176-2.16 2.184-2.22 2.285-.09.152-.107.226-.107.48s.016.328.107.48c.134.225 4.241 4.325 4.433 4.425.099.052.228.074.44.074.258.001.327-.015.492-.112.222-.13.409-.369.473-.603a1.2 1.2 0 0 0-.066-.709c-.037-.074-.61-.679-1.273-1.345L6.422 8l6.879-.002c5.642-.001 6.906-.011 7.029-.055.221-.079.414-.241.539-.454.095-.161.111-.233.111-.489 0-.254-.017-.328-.108-.484a1.02 1.02 0 0 0-.582-.461C20.138 6.009 18.947 6 13.265 6H6.422l1.204-1.21c.663-.665 1.238-1.273 1.279-1.35.052-.099.074-.227.074-.44.001-.255-.015-.328-.107-.484a1.016 1.016 0 0 0-1.232-.448m8.03 9.993c-.222.081-.42.248-.542.455-.092.156-.108.229-.107.484 0 .213.022.341.074.44.041.077.616.685 1.279 1.35L17.578 16h-6.843c-5.682 0-6.873.009-7.025.055a1.02 1.02 0 0 0-.582.461c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.123.044 1.387.054 7.029.055l6.879.002-1.204 1.21c-.663.665-1.236 1.271-1.273 1.345-.229.454-.045 1.046.407 1.312.165.097.235.113.492.113.254 0 .328-.016.48-.107.225-.134 4.325-4.241 4.425-4.433.052-.099.074-.228.074-.44.001-.255-.015-.327-.106-.48-.06-.101-1.039-1.108-2.22-2.285-1.905-1.897-2.132-2.111-2.31-2.17a1 1 0 0 0-.673-.004"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default SwitchHorizontal2Icon;
